import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchUnreadMessages = createAsyncThunk(
    'contract/fetchUnreadMessages',
    async (_, { rejectWithValue }) => {
        try {

            const response = await getRequest({}, 'dms-hr', 'getUnreadMessagesPresence', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { unreadMessagesPresence: data.UnreadMessagesPresence };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);